import { render, staticRenderFns } from "./Managementdef.vue?vue&type=template&id=2e8cec8e&scoped=true&"
import script from "./Managementdef.vue?vue&type=script&lang=js&"
export * from "./Managementdef.vue?vue&type=script&lang=js&"
import style0 from "./Managementdef.vue?vue&type=style&index=0&id=2e8cec8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8cec8e",
  null
  
)

export default component.exports